import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './FlashMessage.scss';

const ICONS = {
    danger:  'cancel',
    success: 'check_circle',
    warning: 'warning',
    info:    'info',
};

function FlashItem({ id, type = 'danger', message, onRemove }) {
    const [leaving, setLeaving] = useState(false);

    const dismiss = () => {
        setLeaving(true);
        setTimeout(() => onRemove(id), 200);
    };

    useEffect(() => {
        const t = setTimeout(dismiss, 5000);
        return () => clearTimeout(t);
        // eslint-disable-next-line
    }, []);

    return (
        <div className={`flash flash--${type}${leaving ? ' flash--leaving' : ''}`}>
            <span className="flash__icon material-symbols-outlined material-icons">{ICONS[type] ?? ICONS.info}</span>
            <span className="flash__body">{message}</span>
            <button className="flash__close material-symbols-outlined material-icons" onClick={dismiss} aria-label="Dismiss">close</button>
        </div>
    );
}

export default function FlashMessage({ messages, onRemove }) {
    if (!messages.length) return null;

    return ReactDOM.createPortal(
        <div className="flash-container">
            {messages.map(m => (
                <FlashItem key={m.id} {...m} onRemove={onRemove} />
            ))}
        </div>,
        document.body
    );
}
